import React, { memo } from "react";
import "./styles.scss";
import { Button, Image } from "react-bootstrap";

const titleStyles = {
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "22px",
  color: "#1D2026",
  marginBottom: "8px",
};

const descStyles = {
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "22px",
  color: "#6E7485",
  letterSpacing: "-0.01em",
  marginBottom: "17px",
};

const BASE_URL = process.env.REACT_APP_API_URL;
const userUrl = BASE_URL.split("/api/v1")[0];

const EnrollementInfoCard = ({
  title = "",
  isMobileView = false,
  description,
  thumbnail = "",
  btnProps = {},
  maxHeightOFCard = "257px",
  onButtonClick = () => {},
}) => {
  return (
    <div
      className="card"
      style={{
        padding: "20px 20px 20px 20px",
        borderRadius: "0px",
        height: isMobileView ? "" : "100%",
        maxHeight: maxHeightOFCard,
        overflowY: "auto",
      }}
    >
      <div className="row m-0" style={{ width: "100%", height: "100%" }}>
        <div
          className="col-12 col-lg-4"
          style={{ paddingLeft: "0px", height: "100%" }}
        >
          <Image
            style={{ objectFit: "cover", width: "100%", maxHeight: "220px" }}
            src={thumbnail ? `${userUrl}${thumbnail}` : "/Course Images.svg"}
            rounded
          />
        </div>
        <div className="col-12 col-lg-8">
          <div style={titleStyles}>{title}</div>
          <div style={descStyles}>{description}</div>
          <Button
            className="start-classroom-styles"
            onClick={onButtonClick}
            variant="outline-primary"
          >
            {btnProps?.text}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default memo(EnrollementInfoCard);
